import { createGlobalStyle } from "@oui/system"
import normalize from "./normalize"
import globals from "./globals"

export default createGlobalStyle`
  ${normalize};
  ${globals};
`
